<page-content>
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!is401 && !is404"
                    [title]="'Organization_guests' | translate"
                    [mainActions]="mainActions">
        <div class="search-bar">
          <mat-form-field color="primary" class="">
              <input matInput
                     type="text"
                     maxlength="255"
                     placeholder="{{ 'Filter' | translate }}"
                     #filter
                     (keyup)="onFilterKeyup(filter.value)">
              <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div *ngIf="dataSource.count === 0" class="legend">{{ 'No_guest_yet' | translate }}</div>
        <mat-table *ngIf="dataSource.count > 0 && !isLoading"
                   [dataSource]="dataSource"
                   matSort
                   [matSortStart]="'desc'"
                   (matSortChange)="onSortChange($event)">
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef class="image-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="image-cell">
                    <img *ngIf="row.user.avatar"
                         class="avatar" width="40" height="40"
                         ngSrc="{{conf.storageRootUrl + row.user.avatar}}" alt="avatar"/>
                    <mat-icon *ngIf="!row.user.avatar">
                        account_circle
                    </mat-icon>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'Name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.user.firstName + ' ' + row.user.lastName }}</div>
                    <mat-icon *ngIf="!row.user.active">lock</mat-icon>
                </mat-cell>
<!--                <mat-cell *matCellDef="let row; let i = index" class="name-cell">-->
<!--                    <div *ngIf="row.rights.view; else notLink">-->
<!--                        <a (click)="onDisplayGuestClicked(row)">{{ row.user.firstName + ' ' + row.user.lastName }}</a>-->
<!--                    </div>-->
<!--                    <ng-template #notLink>-->
<!--                        <div>{{ row.user.firstName + ' ' + row.user.lastName }}</div>-->
<!--                    </ng-template>-->
<!--                </mat-cell>-->
            </ng-container>
            <ng-container matColumnDef="athletes">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Athletes' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    {{ row.athleteNames.join(', ') }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="teams">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Teams' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.teamNames.join(', ') }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="notvalidate" *ngIf="this.rights.SEND_INVITATION">
                <mat-header-cell *matHeaderCellDef class="special-actions-cell"> </mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="special-actions-cell">
                    <div><span *ngIf="row.rights.sendInvitation && (row.user.validateDate === null || row.user.validateDate === undefined)" class="material-icons" [matTooltip]="'account_not_validated' | translate">help_outline</span></div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="special-actions-cell"></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="special-actions-cell">
                    <button *ngIf="row.rights.edit || row.rights.changeAthletes || row.rights.changeTeams || row.rights.delete"
                            mat-icon-button
                            [matMenuTriggerFor]="rowMoreMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                        <button mat-menu-item
                                [disabled]="!row.rights.edit"
                                (click)="onModifyGuestClicked(row)">
                            <mat-icon>edit_outlined</mat-icon>&nbsp;{{ 'Edit' | translate }}
                        </button>
                        <button mat-menu-item
                                [disabled]="!row.rights.changeAthletes"
                                (click)="onManageAthletesClicked(row)">
                            <mat-icon>assignment_ind</mat-icon>&nbsp;{{ 'Athletes' | translate }}
                        </button>
                        <button mat-menu-item
                                [disabled]="!row.rights.changeTeams"
                                (click)="onManageTeamsClicked(row)">
                            <mat-icon>assignment</mat-icon>&nbsp;{{ 'Teams' | translate }}
                        </button>
                        <button mat-menu-item
                                *ngIf="row.rights.sendInvitation && (row.user.validateDate === null || row.user.validateDate === undefined)"
                                (click)="onResendInvitationClicked(row.user)">
                            <mat-icon>send</mat-icon>&nbsp;{{ 'Resend_invitation' | translate }}
                        </button>
                        <button mat-menu-item
                                *ngIf="row.user.active"
                                [disabled]="!row.rights.lock"
                                (click)="onEnableGuestClicked(row, false)">
                            <mat-icon>lock</mat-icon>&nbsp;{{ 'Disable' | translate }}
                        </button>
                        <button mat-menu-item
                                *ngIf="!row.user.active"
                                [disabled]="!row.rights.lock"
                                (click)="onEnableGuestClicked(row, true)">
                            <mat-icon>lock_open</mat-icon>&nbsp;{{ 'Enable' | translate }}
                        </button>
                        <button mat-menu-item
                                [disabled]="!row.rights.delete"
                                (click)="onDeleteGuestClicked(row)">
                            <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>
        <center-loader class="paginator-data-placeholder" *ngIf="isLoading"></center-loader>
        <api-paginator *ngIf="guestsPaginator.total > 0" [paginatorFromAPi]="guestsPaginator"
                       (goToFirstPage)="pageChange(1)"
                       (goToPreviousPage)="pageChange(this.activePage -1)"
                       (goToNextPage)="pageChange(this.activePage +1)"
                       (goToLastPage)="pageChange(guestsPaginator.last_page)">
        </api-paginator>
    </module-content>
</page-content>
